import getPublicConfig from '@/utils/getPublicConfig';

const publicRuntimeConfig = getPublicConfig();
const { AWS_S3_URL } = publicRuntimeConfig;

export const toolGroups = [
  {
    id: 1,
    title: 'Before Treatment Checklists',
    link: 'Before Treatment',
    linkId: 'BeforeTreatment',
    items: [
      {
        id: 1,
        link: `${AWS_S3_URL}/hospital_essentials.pdf`,
        title: 'Hospital Essentials Checklist',
        description:
          'Click here to download our list of "must have" hospital essentials to bring with you for surgery. Recommendations are based on what we couldn\'t live without during our own surgery, as well as interviews with more than 250 patients and survivors.  ',
        imageUrl: `${AWS_S3_URL}/tools/hospital_essentials_checklist.jpg`,
        thumbnail: `${AWS_S3_URL}/tools/hospital_essentials_checklist_thumb.png`,
      },
      {
        id: 2,
        link: `${AWS_S3_URL}/questions_to_ask.pdf`,
        title: 'Questions to Ask Your Doctor',
        description:
          'Your first visit to the Oncologist can bring up all sorts of emotions. Keep yourself and your care on track by downloading this simple checklist to write down your questions in advance, and bring it with you to your appointment to make sure you get all of your questions answered. ',
        imageUrl: `${AWS_S3_URL}/tools/questions_list.jpg`,
        thumbnail: `${AWS_S3_URL}/tools/questions_list_thumb.png`,
      },
    ],
  },
  {
    id: 2,
    title: 'During Treatment Checklists',
    link: 'During Treatment',
    linkId: 'DuringTreatment',
    items: [
      {
        id: 3,
        link: `${AWS_S3_URL}/pain_tracker.pdf`,
        title: 'Pain Diary',
        description:
          "Ouch. We know it hurts. For people with chronic conditions, there often isn't a straight line to feeling better. Use our pain diary to help you identify patterns for your symptoms, learn what your triggers are, and pinpoint treatments that actually work to ease your pain.",
        imageUrl: `${AWS_S3_URL}/tools/pain_diary.jpg`,
        thumbnail: `${AWS_S3_URL}/tools/pain_diary_thumb.png`,
      },
      {
        id: 4,
        link: `${AWS_S3_URL}/symptom_tracker.pdf`,
        title: 'Symptom Tracker',
        description:
          'Not feeling well? Sometimes tracking your symptoms over a period of time can help you and your doctor see patterns or clues that give insights on how to help you feel better faster.',
        imageUrl: `${AWS_S3_URL}/tools/symptom_tracker.jpg`,
        thumbnail: `${AWS_S3_URL}/tools/symptom_tracker_thumb.png`,
      },
      {
        id: 5,
        link: `${AWS_S3_URL}/medication_tracker.pdf`,
        title: 'Medication Tracker',
        description:
          "We know from experience that keeping track of medications isn't always easy. Download our free medication tracker to have all of your pharmacy and prescription data in one place for easy access.  ",
        imageUrl: `${AWS_S3_URL}/tools/medication_tracker.jpg`,
        thumbnail: `${AWS_S3_URL}/tools/medication_tracker_thumb.png`,
      },
    ],
  },
  {
    id: 3,
    title: 'After Treatment Checklists',
    link: 'After Treatment',
    linkId: 'AfterTreatment',
    items: [
      {
        id: 6,
        link: `${AWS_S3_URL}/survivor_plan.pdf`,
        title: 'Care Schedule',
        description:
          'You may have finished treatment, but are you taking an active role in your care? Download our quick and easy survivor care planner to have all of your medical information and appointment data all in one place.',
        imageUrl: `${AWS_S3_URL}/tools/care_schedule.jpg`,
        thumbnail: `${AWS_S3_URL}/tools/care_schedule_thumb.png`,
      },
    ],
  },
];

export const findToolGroupByURL = (url: string) => {
  let resultToolObject;
  toolGroups.forEach((tool) => {
    tool.items.forEach((toolItem) => {
      if (toolItem.link.includes(url.split('/').pop()))
        resultToolObject = toolItem;
    });
  });
  return resultToolObject;
};
